// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousWednesday as fn } from "../previousWednesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousWednesdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default previousWednesdayWithOptions;
